import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { ProductType } from '../../../../core/interfaces/total-reports/product-type.interface';
import { ProductService } from '../../../../core/services/product/product.service';
import { LoadProductsForBrand } from './products.actions';
import { ProductsStateModel } from './products.models';

@Injectable()
@State<ProductsStateModel>({
    name: 'productsState',
    defaults: {
        productsByBrand: {},
    },
})
export class ProductsState {
    constructor(private readonly productService: ProductService) {}

    @Selector()
    static getProductsByBrand(state: ProductsStateModel): Record<number, ProductType[]> {
        return state.productsByBrand;
    }

    static getProductsForBrand(brandId: number) {
        return (state: { productsState: ProductsStateModel }): ProductType[] =>
            state.productsState?.productsByBrand?.[brandId] ?? [];
    }

    @Action(LoadProductsForBrand)
    loadProductsForBrand(ctx: StateContext<ProductsStateModel>, { brandId }: LoadProductsForBrand) {
        const existing = ctx.getState().productsByBrand[brandId];
        if (existing) {
            return;
        }
        return this.productService.getProducts().pipe(
            tap((products) => {
                ctx.patchState({
                    productsByBrand: {
                        ...ctx.getState().productsByBrand,
                        [brandId]: products,
                    },
                });
            }),
        );
    }
}
